// src/components/RequireInternal.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isClientUser, readStoredUser } from '../utils/userFlags.js';

export default function RequireInternal({ children }) {
  const location = useLocation();
  const user = readStoredUser();
  const isClient = isClientUser(user);

  // if they aren’t logged in, delegate to your login route
  if (!user?.userid) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // block clients from internal-only routes
  if (isClient) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
